import axios from 'axios';

export const postSendError = async (requestData) => {
    return await axios.post('/api/public/send_error/', requestData);
};
